import { Link } from 'react-router-dom';
import { useT } from '@/shared/i18n/useT';
import { cn } from '@/shared/utils/cn';
import { DomainIcon } from '../icons/DomainIcon';
import { buttonVariants } from '../ui/buttonVariants';

export interface NotificationBellProps {
  /** Notificaciones sin leer. 0 oculta el contador. */
  unread: number;
}

/** Campana con contador (9+ como tope). El nombre accesible incluye cuántas hay sin leer. */
export function NotificationBell({ unread }: NotificationBellProps) {
  const { t } = useT();
  const label =
    unread > 0 ? t('aria.notificationsUnread', { count: unread }) : t('aria.notifications');
  return (
    <Link
      to="/notificaciones"
      aria-label={label}
      className={cn(buttonVariants({ variant: 'ghost' }), 'relative size-11 px-0')}
    >
      <DomainIcon id="campana" size={20} />
      {unread > 0 ? (
        <span
          aria-hidden="true"
          className="num absolute right-1 top-1 grid h-[18px] min-w-[18px] place-items-center rounded-full bg-accent px-1 text-[11px] font-bold leading-none text-accent-fg ring-2 ring-bg"
        >
          {unread > 9 ? '9+' : unread}
        </span>
      ) : null}
    </Link>
  );
}
